import React from 'react'
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import "./TitleDivSeo.css"
// import { useContext } from 'react';
// import { StatusContext } from '../ContextApiStatus';

function HtmlWithText(props) {



    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }



  return (
    <div>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>حجم النص وملف ال HTML </h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
          نسبة النص لديك بالنسبة لحجم ملف ال HTML  الخاص بك هو  {props.textContentPercentage} %
        </Typography>
        <hr style={{marginTop:"5px"}} />
        <Typography style={{marginTop:"5px"}} level="body-sm">
            حجم النص الذي يحتوي عليه موقعك هو {props.textContentSize} B
        </Typography>
        <hr />
        <Typography style={{marginTop:"5px"}} level="body-sm">
            حجم ملف ال HTML كامل الخاص بك هو {props.htmlSize} B
        </Typography>
      </CardContent>
      { props.textContentPercentage >= 70 ? (
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} />
) : props.textContentPercentage >= 50 && props.textContentPercentage < 70 ? (
  <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} />
) : <ClearIcon style={{ color: "red",fontSize: "50px" }} /> }
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
          تمثل نسبة التعليمات البرمجية إلى النص النسبة المئوية للنص الفعلي على صفحة الويب مقارنة بنسبة كود HTML ، ويتم استخدامه بواسطة محركات البحث لحساب مدى ملاءمة صفحة الويب.
ستزيد نسبة الكود إلى النص الأعلى من فرصك في الحصول على ترتيب أفضل في نتائج محرك البحث.
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
export default HtmlWithText